
import { BiSolidMessageError } from "react-icons/bi";
export const public_url = "boc-public/";
export const ERROR_MSG = (<b><BiSolidMessageError size={18} /> Required</b>)
export const ALPHABETS_ONLY_Msg = (<b><BiSolidMessageError size={18} />Enter Only letters</b>);
export const NUMERIC_Msg = "Enter Only Numbers";
export const Aadhaar_Msg = "Invalid Aadhaar!";
export const Mobile_Msg = "Invalid Mobile No. !";
export const LandLine_Msg = "Invalid Landline No. !";
export const Meeseva_Msg = "Invalid Meeseva No. !";
export const HT_Msg = "Invalid Hall Ticket No. !";
export const Addres_Msg = "Dont Use Special Characters";
export const Percentage_Msg = "Invalid Percentage";
export const USERNAME_REG = /^MDFC\d{7}$/;
export const alphaNumeric_VALIDATION = /^[a-zA-Z0-9]*$/;
export const Percentage_Validation = /^(3[5-9]|[4-9][0-9]|100)(\.[0-9])?$/
export const IFSC_VALIDATION = /^[A-Z]{4}0[A-Z 0-9]{6}$/;
export const AADHAR_VALIDATION = /^[2-9]{1}[0-9]{11}$/
export const MOBILE_VALIDATION = /^[6-9]{1}[0-9]{9}$/;
export const LANDLINE_VALIDATION = /^(0[1-9]\d{1,4}-[1-9]\d{6,7}|[1-9]\d{1,4}-[1-9]\d{6,7})$/;
export const MEESEVA_NO_VALIDATION = /^ME\d{6}$/;
export const PAN_VALIDATION = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
export const TAN_VALIDATION = /^[A-Z]{4}[0-9]{5}[A-Z]{1}$/;
export const PINCODE = /^[1-9]{1}[0-9]{5}$/;
export const ONLY_NUMERIC = /^[0-9]+$/;
export const ONLY_CAPS = /^[A-Z\s]+$/;
export const NUMERIC = /^\d+$/;
export const ALPHABETS_ONLY = /^[A-Za-z\s]+$/;
export const STARTS_WITH_NO_WHITESPACE = /^(?!\s+$).*/;
export const AddresRemarks = /^[0-9a-zA-Z\s,.$%#@-]+$/;
export const GSTIN_VALIDATION = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[A-Z0-9]{1}[Z]{1}[A-Z0-9]{1}$/;
export const PASSWORD_VALIDATION = /^.*(?=.{8,})((?=.*[!@#$%^&*()\-_=+{};:,<.>]){1})(?=.*\d)((?=.*[a-z]){1})((?=.*[A-Z]){1}).*$/;
export const PASSWORD_MSG = (<b><BiSolidMessageError size={18} />Password must contain at least 8 characters, one uppercase, one number, and one special case character</b>);

export const handleKeyPressNumeric = (e) => {
    const allowedChars = /^[0-9]$/;
    if (!allowedChars.test(e.key)) {
        e.preventDefault();
    }
};
export const handleNumericDot = (e) => {
    const allowedChars = /^[0-9.]$/;
    if (!allowedChars.test(e.key)) {
        e.preventDefault();
    }
};
export const handleKeyAlphaNumeric = (e) => {

    if (!alphaNumeric_VALIDATION.test(e.key)) {
        e.preventDefault();
    }
};
export const handleKeyPressAlphabets = (e) => {

    if (!ALPHABETS_ONLY.test(e.key)) {
        e.preventDefault();
    }
};
export const handleKeyPressAlphabetsAndSpecialCharsWithSpace = (e) => {
    const ALPHABETS_AND_SPECIAL_CHARS_WITH_SPACE = /^[A-Za-z!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?\s]*$/;

    if (!ALPHABETS_AND_SPECIAL_CHARS_WITH_SPACE.test(e.key)) {
        e.preventDefault();
    }
};


export const handleInputToUppercase = (e) => {
    e.target.value = e.target.value.toUpperCase();
};
export const MaskAadhaar = (num) => {
    // Check if the Aadhaar number is empty or invalid
    if (!num) {
        return ""; // or return an empty string or any other fallback
    }
    num = String(num);
    // Validate the input (should be exactly 12 digits)
    if (!/^\d{12}$/.test(num)) {
        return "";  // Handle invalid input gracefully
    }
    // Mask the first 8 digits and leave the last 4 digits visible
    return num.slice(0, 8).replace(/\d/g, 'X') + num.slice(8);
};

export function allowCharsAndNumericMaxSpaces(e) {
    const charCode = e.keyCode === 0 ? e.charCode : e.keyCode;
    const currentInput = e.target.value;
   
    const isAlphabetic = (charCode >= 65 && charCode <= 90) || (charCode >= 97 && charCode <= 122);
    const isNumeric = charCode >= 48 && charCode <= 57;
    const isSpace = charCode === 32;
    const lastCharIsSpace = currentInput.endsWith(' ');
 
    // Allow alphabetic and numeric characters
    if (isAlphabetic || isNumeric) {
        return true;
    }
 
    // Allow space only if the last character is NOT a space
    if (isSpace && !lastCharIsSpace) {
        return true;
    }
 
    // Block input
    e.preventDefault();
    return false;
}
 